import { createAction, props } from '@ngrx/store';
import { OracleStorageActionModel } from '@models/common/oracle-storage-action.model';
import { QueryModel } from '@models/configuration/query.model';

export const createQuery = createAction(
    '[Query] Create Query',
    props<{ action: OracleStorageActionModel<QueryModel> }>()
);

export const createQuerySuccess = createAction(
    '[Query] Create Query Success',
    props<{ Query: QueryModel }>()
);

export const searchQueries = createAction(
    '[Queries] Search Queries',
    props<{ action: OracleStorageActionModel<QueryModel> }>()
);

export const searchQueriesSuccess = createAction(
    '[Queries] Search Queries Success',
    props<{ Queries: QueryModel[] }>()
);

export const searchQueryOne = createAction(
    '[QueryOne] Search QueryOne',
    props<{ action: OracleStorageActionModel<QueryModel> }>()
);

export const searchQueryOneSuccess = createAction(
    '[QueryOne] Search QueryOne Success',
    props<{ QueryOne: QueryModel[] }>()
);

export const updateQuery = createAction(
    '[Query] Update Query',
    props<{ action: OracleStorageActionModel<QueryModel> }>()
);

export const updateQuerySuccess = createAction(
    '[Query] Update Query Success',
    props<{ Query: QueryModel }>()
);

export const selectQuery = createAction(
    '[Query] Select Query',
    props<{ Query: QueryModel }>()
);

export const setCurrentQuery = createAction(
    '[Query] Current Query',
    props<{ rowKey: string | null }>()
);

export const deleteQuery = createAction(
    '[Query] Delete Query',
    props<{ action: OracleStorageActionModel<QueryModel> }>()
);

export const deleteQuerySuccess = createAction(
    '[Query] Delete Query Success',
    props<{ Query: QueryModel }>()
);

export const cleanQuery = createAction(
    '[Query] Clean Query',
    props<{ QueryOne: any[] }>()
);

export const resetLoading = createAction(
    '[Loading] Reset Loading Success'
);